module.exports = __webpack_public_path__ + "img/settings-dark-green-outline.a6e02834.svg";